import thunkMiddleware from 'redux-thunk';
import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import rootReducer from './reducers/index';
import { StoreState } from './store-interfaces';

export const reduxStore = createStore<StoreState>(
  rootReducer,
  composeWithDevTools({ trace: true, traceLimit: 20 })(
    applyMiddleware(thunkMiddleware),
  ),
);

export default reduxStore;
